import { FilterSearchItemService } from './../../services/filter-search-item.service';
import { Subscription } from 'rxjs';
import { VehiculeserviceService } from './../../services/vehiculeservice.service';
import { ActivatedRoute } from '@angular/router';
import { TemplateSearchCar } from 'src/app/app.models';
import { DataSearchService } from './../../services/data-search.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-search-car',
  templateUrl: './search-car.component.html',
  styleUrls: ['./search-car.component.scss']
})
export class SearchCarComponent implements OnInit, OnDestroy {

  public dataSearch: TemplateSearchCar;

  //Subscription
  routeSubscription: Subscription;
  vehiculeServiceSubscription: Subscription;

  geometry: any;
  address: string;

  public numberOfResult: number;
  public cars: any;
  public carsInit: any;

  public markers: any;
  public model: any;

  public showSpinner: boolean;

  public types: any[];

  public diffWeek: any;


  constructor(public dataSearchService: DataSearchService,
    private route: ActivatedRoute,
    private vehiculeService: VehiculeserviceService,
    private filterSearchService: FilterSearchItemService,
    private appService: AppService,private spinner: NgxSpinnerService,
  ) { }



  ngOnInit(): void {

    this.initProperty();

  }

  private initProperty() {

    //Données recuperer dans l'observable
    this.routeSubscription = this.route.data.subscribe(data => {

      this.numberOfResult = data.cars.cars.length;

      this.cars = data.cars.cars;

      

      this.markers = data.cars.markers;

      this.dataSearchService.markers = data.cars.markers;

      this.carsInit = data.cars.cars;

    })

    //Tableau contenant les élèments de recherches
    this.dataSearch = this.dataSearchService.templateSearchCar;

     if (this.dataSearch != undefined) {
      if (this.dataSearch.address != undefined) {
        this.address = this.dataSearch.address;
      } else {
        this.address = this.dataSearchService.address;
      }

      this.geometry = this.dataSearch.geometry;
    } else {

      this.address = "";

    }

    //Visibilité de l'animation
    this.showSpinner = false;

    //Catégories de véhicules
    this.model= this.dataSearchService.Model ;

    
      
    this.types = this.appService.getCategorieVehicule();
  }

  //Cette methode permet d'écouter l'adresse emise
  send(address: any) {

    this.geometry = address.geometry; 

    this.address = address.formatted_address;

    this.dataSearchService.geometry = address.geometry;

    // console.log(this.dataSearchService.geometry);

    this.addressOrDateChange(address.formatted_address, 'address')

  }

  //Cette methode permet d'écoute l'evenement qui est emit lorsque la date de fin est enregistré
  sendDate(diff: any) {

    this.diffWeek = diff;

    this.addressOrDateChange(diff, 'date')

  }


  //Cette methode permet d'ecouter les élèments de recherches emits
  sendItemSearch(itemSearch: any) {

    let currentCars = this.filterSearchService.itemSearchSend(itemSearch, this.cars);

    this.cars = currentCars;

    this.numberOfResult = currentCars.length;


    // console.log(currentCars);

  }

  //Permet de reinitialiser la liste des véhicules après le clic sur le button de reinitialisation
  sendButtonReset(val: boolean) {

    if (val) {

      this.cars = this.carsInit;

      this.numberOfResult = this.carsInit.length;


    }

  }

  //Cette methode est appelée lorsque l'adresse ou les dates de location sont modifiés
  addressOrDateChange(CurrentValue: string, key: string) {

    let objPost;
    let latitude= typeof this.dataSearchService.geometry.location.lat === 'function'?this.dataSearchService.geometry.location.lat():this.dataSearchService.geometry.location.lat;
    let longitude= typeof this.dataSearchService.geometry.location.lng === 'function'?this.dataSearchService.geometry.location.lng():this.dataSearchService.geometry.location.lng;



    if (key == 'address') {

      if (this.diffWeek == undefined) {
        objPost = {
          // address: CurrentValue, 
          diffDate: null,
          lat: latitude,
          lng: longitude
        }

      } else {
        objPost = {
          // address: CurrentValue, 
          diffDate: this.diffWeek,
          dateStart: this.dataSearchService.templateSearchCar.dateStart,
          dateEnd: this.dataSearchService.templateSearchCar.dateEnd,
          lat: latitude,
          lng: longitude
        }

      }


    } else {
      objPost = {
        // address: this.address, 
        diffDate: CurrentValue,
        dateStart: this.dataSearchService.templateSearchCar.dateStart,
        dateEnd: this.dataSearchService.templateSearchCar.dateEnd,
        lat: latitude,
        lng: longitude
      }

    }

    this.showSpinner = true;
    this.spinner.show();

    this.vehiculeServiceSubscription = this.vehiculeService.searchCar(objPost).subscribe((res: any) => {
      this.showSpinner = false;
      this.spinner.hide();
      this.cars = res['cars'];
      this.numberOfResult = res['cars'].length;
      this.markers = res['markers'];
      this.carsInit = res['cars'];
      this.dataSearchService.markers = res['markers'];
    },
      (error) => {
        // throw error;
    })

  }

  ngOnDestroy(): void {
    if (this.showSpinner) {
      this.vehiculeServiceSubscription.unsubscribe();
    }
    this.routeSubscription.unsubscribe();
  }

}